<template>
    <div class="intro-edit">
        <data-form title="Intro Paragraph Edit"
                   tag="intro-edit"
                   save-button-label="Save"
                   :field-model="introFields"
                   :field-groups="fieldGroups"
                   :load-model-instance="loadModelInstance"
                   :on-submit-handler="onSubmit"
                   :cancelRoute="`/intro/view/${introId}`"
                   submit-success-message="Intro Paragraph updated"
                   submit-error-message="Error updating intro paragraph"
                   :submit-success-route="`/intro/view/${introId}`">
        </data-form>
    </div>
</template>

<script>

import Vue from 'vue'
import IntroFields from '@/models/Intro'

export default Vue.extend({
    name: 'IntroEdit',
    props: {
        introId: Number,
    },
    data () {
        return {
            introFields: IntroFields,
            fieldGroups: [
                ['id', 'route', 'content']
            ],
        }
    },
    methods: {
        async loadModelInstance () {
            return this.$api.getItem(this, 'intro', this.introId)
        },
        onSubmit (modelInstance) {
            this.$store.dispatch('submit', {
                mutation: 'clearIntros'
            })
            return this.$api.updateItem(this, 'intro', modelInstance)
        },
    }
})

</script>
